const rng = (seed) => {
  let s = seed;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
};

const daysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString();
};

const buildLineSeries = (seed, base, variance) => {
  const r = rng(seed);
  return Array.from({ length: 30 }, (_, i) => ({
    date: daysAgo(29 - i),
    count: Math.max(0, Math.round(base + (r() - 0.5) * variance + Math.sin(i / 4) * variance * 0.4)),
  }));
};

const avg = (arr) => Math.round(arr.reduce((a, b) => a + b.count, 0) / arr.length);

export const buildDashboardStats = () => {
  const openAccount = buildLineSeries(101, 4800, 320);
  const failed = buildLineSeries(102, 6, 4);
  const activeAlert = buildLineSeries(103, 22, 12);
  return {
    openAccount: { avg: avg(openAccount), statistics: openAccount },
    failed: { avg: avg(failed), statistics: failed },
    activeAlert: { avg: avg(activeAlert), statistics: activeAlert },
  };
};

const USER_TYPES = ['employee', 'temp', 'client', 'supplier'];
const LEVELS = ['LEVEL_1', 'LEVEL_2', 'LEVEL_3'];

const buildBranch = (seed, seriesNames) => {
  const r = rng(seed);
  const out = [];
  for (let day = 29; day >= 0; day--) {
    const dateStr = daysAgo(day);
    seriesNames.forEach((s) => {
      const count = 50 + Math.floor(r() * 250);
      const total = count + Math.floor(r() * 300);
      out.push({ date: dateStr, serie: s, count, total });
    });
  }
  return out;
};

// Charts attend kpiStatistics.{all,type,level}
export const buildKpiSeries = () => ({
  all: buildBranch(200, ['all']),
  type: buildBranch(217, USER_TYPES),
  level: buildBranch(231, LEVELS),
});

export const buildOpenedAccountsSeries = () => buildLineSeries(301, 4800, 320);
